export const MAX_ALLOWED_SPLIT = 5;
